import React from "react";

const AnalyticsAppContext = React.createContext({});

export default AnalyticsAppContext;